import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  getAllPortDataimport,
  uploadPortDataFile,
} from "./services/portDataimport";
import { IIPortDataimportInitialState, IPortDataimport } from "./portModel";

const initialState: IIPortDataimportInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  PortDataimportID: "",
  PortDataimportList: [],
  FilterCustomPIT: {
    sb_no: "",
    sb_date: "",
    leo_date: "",
    lec: "",
    exporter_name: "",
    consignee_name: "",
    country_of_destination: "",
    port_of_discharge: "",
  },
  PortDataimportDetail: {
    File: "",
    sb_no: "",
    sb_date: "",
    leo_date: "",
    lec: "",
    exporter_name: "",
    consignee_name: "",
    country_of_destination: "",
    port_of_discharge: "",
  },
  filter: {
    sb_no: "",
    sb_date: "",
    leo_date: "",
    lec: "",
    exporter_name: "",
    consignee_name: "",
    country_of_destination: "",
    port_of_discharge: "",
    limit: 10,
    skip: 0,
  },
  isFilterSet: false,
};

const portdataimportSlice = createSlice({
  name: "portdataimport",
  initialState,
  reducers: {
    clearPortimportDataDetails: (state) => {
      state.PortDataimportDetail = initialState.PortDataimportDetail;
    },
    setFilterCustomPIT: (state, action) => {
      state.FilterCustomPIT = action.payload;
    },
    clearFilterCustomPIT: (state) => {
      state.FilterCustomPIT = initialState.FilterCustomPIT;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
      state.isFilterSet = true;
    },
    clearFilter: (state) => {
      state.filter = initialState.filter;
      state.isFilterSet = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllPortDataimport.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPortDataimport.fulfilled,
      (state, action: PayloadAction<IPortDataimport[]>) => {
        state.loading = false;
        state.PortDataimportList = action.payload || [];
      }
    );
    builder.addCase(getAllPortDataimport.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PortDataimportList = [];
    });

    builder.addCase(uploadPortDataFile.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });

    builder.addCase(uploadPortDataFile.fulfilled, (state) => {
      state.formLoading = false;
    });

    builder.addCase(uploadPortDataFile.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});
export const {
  clearPortimportDataDetails,
  clearFilterCustomPIT,
  setFilterCustomPIT,
  clearFilter,
  setFilter,
} = portdataimportSlice.actions;
export default portdataimportSlice.reducer;
